import React, { useState } from "react";
import { RCCButton, RCCGrid, RCCIcon, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import LovUsers from "../Lov/Users";
import LovUsersGroups from "../Lov/UsersGroups";
import Select from "../Select";
import Title from "../Title";

import { IComponentPermissions, IPermissions, simplePermissionType,completePermissionType, reportPermissionType } from "./interface";

const Permissions: React.FC<IComponentPermissions> = ({
	unregister,
	control,
	error,
	permissionsNames,
	register,
	clearErrors,
	disabled,
	permissionType = "simple",
	customPermissionOptions,
	additionalFields
}) => {
	const { translate } = useTranslation();
	const convertDefaultValueToPermissions = (defaultValue: Array<any>): IPermissions[] => defaultValue.map((dfvalue) => ({
		...dfvalue,
		id: dfvalue[permissionsNames.nameOfID],
		efa005Id: dfvalue[permissionsNames.nameOfSelectUser],
		efa004Id: dfvalue[permissionsNames.nameOfSelectGroup],
		efa005Nome: permissionsNames.nameOfSelectUserDescription ? dfvalue[permissionsNames.nameOfSelectUserDescription] : undefined,
		efa004Descricao: permissionsNames.nameOfSelectGroup ? dfvalue[permissionsNames.nameOfSelectGroupDescription || ""] : undefined,
		permission: permissionsNames.nameOfSelectPermission ? String(dfvalue[permissionsNames.nameOfSelectPermission]) : undefined
	}));
	const [permissions, setPermissions] = useState<IPermissions[]>(permissionsNames.defaultValue ? convertDefaultValueToPermissions(permissionsNames.defaultValue) : []);
	const initalPermission = simplePermissionType.VIEW;
	const permissionsOptions = {
		simple: [{
			value: simplePermissionType.NO_PERMISSION,
			label: translate("Sem Permissão")
		},
		{
			value: simplePermissionType.VIEW,
			label: translate("Visualiza")
		},
		{
			value: simplePermissionType.VIEW_AND_EDIT,
			label: translate("Visualiza e edita")
		}],
		complete: [{
			value: completePermissionType.NO_PERMISSION,
			label: translate("Sem Permissão")
		},
		{
			value: completePermissionType.VIEW,
			label: translate("Visualiza")
		},
		{
			value: completePermissionType.VIEW_AND_ANALIZE,
			label: translate("Visualiza e analisa")
		},
		{
			value: completePermissionType.VIEW_AND_CHANGE_VALUES,
			label: translate("Visualiza e altera valores")
		},
		{
			value: completePermissionType.VIEW_AND_CHANGE_VALUES_GOAL,
			label: translate("Visualiza e altera meta e valores")
		},
		{
			value: completePermissionType.VIEW_AND_EDIT,
			label: translate("Visualiza e edita")
		}],
		report: [{
			value: reportPermissionType.NO_PERMISSION,
			label: translate("Sem Permissão")
		},
		{
			value: reportPermissionType.VIEW,
			label: translate("Visualiza")
		}]
	};

	const addNewPermission = (type: "user" | "group") => {
    	if(type === "user"){
    		setPermissions((prevState) => [...prevState, {efa005Id: 0, id: 0, permission: initalPermission}]);
			return;
		}
		setPermissions((prevState) => [...prevState, {efa004Id: 0, id: 0, permission: initalPermission}]);
	};

	const removePermission = (index: number) => {
    	unregister(`${permissionsNames.nameObject}`);
		clearErrors(permissionsNames.nameObject);
    	setPermissions((prevState) => prevState.filter((_, idx) => idx !== index));
	};

	const onChangeSelect = (option: { value: string, label: string}, index: number, type: "user" | "group" | "permission") => {
		clearErrors(permissionsNames.nameObject);
		if(type === "user"){
			setPermissions((prevState) => {
				const updateState = [...prevState];
				updateState[index].efa005Id = Number(option.value);
				updateState[index].efa005Nome = option.label;
				return updateState;
			});
			return;
		}

		if(type === "group"){
			setPermissions((prevState) => {
				const updateState = [...prevState];
				updateState[index].efa004Id = Number(option.value);
				updateState[index].efa004Descricao = option.label;
				return updateState;
			});
			return;
		}
		
		if(type === "permission"){
			setPermissions((prevState) => {
				const updateState = [...prevState];
				updateState[index].permission = option.value;
				return updateState;
			});
		}

	};

	return (
		<RCCGrid
			container
			item
			direction="column"
			alignItems="center"
			justifyContent="center"
		>
			
			<RCCGrid
				container
				item
				direction="column"
			>
				<RCCGrid 
					container
					item
				>
					<RCCTooltip
						color="purple"
						text={translate("Adicionar usuário")}
					>
						<RCCButton
							color="purple"
							icon={{
								name: "plus"
							}}
							disabled={disabled}
							onClick={() => addNewPermission("user")}
						>
							{translate("Usuário")}
						</RCCButton>
					</RCCTooltip>
					<RCCTooltip
						color="grey"
						text={translate("Adicionar grupo")}
					>
						<RCCButton
							color="grey"
							icon={{
								name: "plus"
							}}
							disabled={disabled}
							onClick={() => addNewPermission("group")}
						>
							{translate("Grupo")}
						</RCCButton>
					</RCCTooltip>
				</RCCGrid>
				<RCCGrid
					container
					item
					alignItems="center"
					justifyContent="flex-end"
					style={{minHeight: "24px"}}
				>
					{error[permissionsNames.nameObject] && (
						<>
							<RCCIcon name="infoCircle" size={18} color="var(--red)"/>
							<Title color="red" size="xs">{error[permissionsNames.nameObject].message}</Title>
						</>
					)}
				</RCCGrid>
				{/* Users */}
				<RCCGrid
					container
					item
					direction="column"
					alignItems="center"
					justifyContent="center"
				>
					<RCCGrid
						container
						item
					>
						{permissions && permissions.filter((user) => user.efa005Id !== undefined && user.efa005Id !== null).length > 0 && (
							<RCCGrid
								container
								item
							>
								<Title color="purple"
									size="sm"
								>
									{translate("Usuários")}
								</Title>
								<hr />
							</RCCGrid>
						)}
						{permissions && permissions.map((permission, index) => permission.efa005Id !== undefined && permission.efa005Id !== null && (<RCCGrid
							key={v4()}
							container
							item
							alignItems="baseline"
							justifyContent="space-between"
						>
							<input 
								name={`${permissionsNames.nameObject}[${index}].${permissionsNames.nameOfID}`} 
								type="text"
								value={permission.id}
								{...register(`${permissionsNames.nameObject}[${index}].${permissionsNames.nameOfID}`)} 
								style={{ display: "none" }} 
								readOnly
							/>
							
							<RCCGrid
								container
								item
								md={permissionType !== "hidePermissions" && permissionsNames.nameOfSelectPermission ? 5 : 10}
								xs={12}
							>
								<LovUsers 
									control={control}
									onChangeCapture={(option:any) => onChangeSelect(option, index, "user")}
									name={`${permissionsNames.nameObject}[${index}].${permissionsNames.nameOfSelectUser}`}
									label=""
									defaultValue={permission.efa005Id && (permission.efa005Nome ? { value: String(permission.efa005Id), label: permission.efa005Nome } : permission.efa005Id.toString())}
									error={error[permissionsNames.nameObject] && error?.[permissionsNames.nameObject][index]?.[permissionsNames.nameOfSelectUser]}
									disabled={disabled}
									required
									styleInline="height: 40px; min-height: 40px;"
								/>
							</RCCGrid>
							
							{permissionType !== "hidePermissions" && permissionsNames.nameOfSelectPermission &&  (
								<RCCGrid
									container
									item
									md={5}
									xs={12}
								>
									<Select 
										onChangeCapture={(option) => onChangeSelect(option, index, "permission")}
										control={control}
										error={error[permissionsNames.nameObject] && error?.[permissionsNames.nameObject][index]?.[permissionsNames.nameOfSelectPermission]}
										name={`${permissionsNames.nameObject}[${index}].${permissionsNames.nameOfSelectPermission}`}
										label=""
										options={customPermissionOptions ?? permissionsOptions[permissionType]}
										defaultValue={permission.permission ? String(permission.permission) : ""}
										disabled={disabled}
										required
										styleInline="height: 40px; min-height: 40px;"
									/>
								</RCCGrid>
							)}
							
							<RCCGrid
								container
								item
								md={1}
								xs={12}>
								<RCCTooltip
									color="red"
									text={translate("Remover")}
								>
									<RCCButton 
										color="red"
										icon={{name: "trash", size: 18}}
										onClick={() => removePermission(index)}
										layout="isRounded"
										size="md"
										disabled={disabled}
									/>
								</RCCTooltip>
							</RCCGrid>
							{additionalFields && (
								<RCCGrid container item>
									{additionalFields(register, control, error, `${permissionsNames.nameObject}[${index}]`, permission, (value: any, key: string) => {
										setPermissions((prevState: any) => {
											const updateState = [...prevState];
											const indexOf = prevState.findIndex((x: any) => x.efa005Id === permission.efa005Id);
											if(indexOf < 0)
												return updateState;
											
											updateState[indexOf] = {
												...permission,
												[key]: value
											};
											return updateState;	
										});
									})}
								</RCCGrid>
							)}
						</RCCGrid>))}
					</RCCGrid>
				</RCCGrid>
				{/* Groups */}
				<RCCGrid
					container
					item
					direction="column"
					alignItems="center"
					justifyContent="center"
				>
					<RCCGrid
						container
						item
					>
						{permissions && permissions.filter((groups) => groups.efa004Id !== undefined && groups.efa004Id !== null).length > 0 && (
							<RCCGrid
								container
								item
							>
								<Title color="purple"
									size="sm"
								>
									{translate("Grupos")}
								</Title>
								<hr />
							</RCCGrid>
						)}
						{permissions && permissions.map((permission, index) => permission.efa004Id !== undefined && permission.efa004Id !== null && (<RCCGrid
							key={v4()}
							container
							item
							alignItems="baseline"
							justifyContent="space-between"
						>
							<input 
								name={`${permissionsNames.nameObject}[${index}].${permissionsNames.nameOfID}`} 
								type="text"
								value={permission.id}
								{...register(`${permissionsNames.nameObject}[${index}].${permissionsNames.nameOfID}`)} 
								style={{ display: "none" }} 
								readOnly
							/>					
							<RCCGrid
								container
								item
								md={permissionType !== "hidePermissions" && permissionsNames.nameOfSelectPermission ? 5 : 10}
								xs={12}
							>
								<LovUsersGroups 
									control={control}
									label=""
									name={`${permissionsNames.nameObject}[${index}].${permissionsNames.nameOfSelectGroup}`}
									defaultValue={permission.efa004Id && (permission.efa004Descricao ? { value: String(permission.efa004Id), label: permission.efa004Descricao } : permission.efa004Id.toString())}
									onChangeCapture={(option:any) => onChangeSelect(option, index, "group")}
									error={error[permissionsNames.nameObject] && error?.[permissionsNames.nameObject][index]?.[permissionsNames.nameOfSelectGroup]}
									disabled={disabled}
									required
									styleInline="height: 40px; min-height: 40px;"
								/>
							</RCCGrid>
							{permissionType !== "hidePermissions" && permissionsNames.nameOfSelectPermission &&  (
								<RCCGrid
									container
									item
									md={5}
									xs={12}
								>
									<Select 
										onChangeCapture={(option) => onChangeSelect(option, index, "permission")}
										control={control}
										error={error[permissionsNames.nameObject] && error?.[permissionsNames.nameObject][index]?.[permissionsNames.nameOfSelectPermission]}
										name={`${permissionsNames.nameObject}[${index}].${permissionsNames.nameOfSelectPermission}`}
										label=""
										options={customPermissionOptions ?? permissionsOptions[permissionType]}
										defaultValue={permission.permission ? String(permission.permission) : ""}
										disabled={disabled}
										required
										styleInline="height: 40px; min-height: 40px;"
									/>
								</RCCGrid>
							)}
							<RCCGrid
								container
								item
								md={1}
								xs={12}>
								<RCCTooltip
									color="red"
									text={translate("Remover")}
								>
									<RCCButton 
										color="red"
										icon={{name: "trash", size: 18}}
										onClick={() => removePermission(index)}
										layout="isRounded"
										size="md"
										disabled={disabled}
									/>
								</RCCTooltip>
							</RCCGrid>
							{additionalFields && (
								<RCCGrid container item>
									{additionalFields(register, control, error, `${permissionsNames.nameObject}[${index}]`, permission, (value: any, key: string) => {
										setPermissions((prevState: any) => {
											const updateState = [...prevState];
											const indexOf = prevState.findIndex((x: any) => x.efa004Id === permission.efa004Id);
											if(indexOf < 0)
												return updateState;
											
											updateState[indexOf] = {
												...permission,
												[key]: value
											};
											return updateState;	
										});
									})}
								</RCCGrid>
							)}
						</RCCGrid>))}
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
			<br />
			<hr />
			
		</RCCGrid>
	);
};

export default Permissions;
